export enum EngagementDocumentStatus {
    PostedForViewing = 0,
    RequiresAction = 1,
    Completed = 2,
    PendingPreparation = 3,
}

export const EngagementDocumentStatusOptions = {
    [EngagementDocumentStatus.PostedForViewing]: 'Viewable',
    [EngagementDocumentStatus.RequiresAction]: 'Requires Action',
    [EngagementDocumentStatus.Completed]: 'Complete',
    [EngagementDocumentStatus.PendingPreparation]: 'Pending Preparation',
};